import styled from '@emotion/styled';
import { alpha, Box, Grid, Typography } from '@mui/material';
import PolarisIcon from '@/components/_common/PolarisIcon';

const OPSelectionsEmpty = ({ text = '' }) => {
  const isFocus = window.location.pathname.includes('focus');

  return (
    <Box>
      <Typography sx={{ mb: 3, opacity: isFocus ? 0.5 : 0.7 }}>{text}</Typography>
      <Grid container justifyContent="center" alignItems="center" sx={{ p: 6, pb: 9 }}>
        <FileSelectionIcon icon="inbox" height={65} focus={isFocus} />
      </Grid>
    </Box>
  );
};

export default OPSelectionsEmpty;

const FileSelectionIcon = styled(PolarisIcon, { shouldForwardProp: (prop) => prop !== 'focus' })<{ focus: boolean }>(({ theme, focus }) => ({
  color: focus ? (theme.palette.mode === 'dark' ? '#3C4249' : alpha('#3C4249', 0.25)) : theme.palette.action.disabled
}));
